import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import {
  track,
  identify,
  Identify
} from '@amplitude/analytics-browser';

const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname + location.search;

    // Send pageview to GA
    ReactGA.send({
      hitType: "pageview",
      page: url,
      userId: localStorage.getItem('userId') || 'non logged in user'
    });

    // Send pageview to Amplitude
    track('Page View', {
      path: location.pathname,
      full_url: url,
      referrer: document.referrer || 'direct',
      env: 'dev', // add if you want to filter by dev events
      user_id: localStorage.getItem('userId') || 'guest'
    });

    // Only track UTM/referrer once per session
    const alreadyTracked = localStorage.getItem('utmTracked');
    if (!alreadyTracked) {
      const params = new URLSearchParams(location.search);
      const utm_source = params.get('utm_source');
      const utm_medium = params.get('utm_medium');
      const utm_campaign = params.get('utm_campaign');

      const identifyObj = new Identify();

      if (utm_source || utm_medium || utm_campaign) {
        // Use real UTM if available
        identifyObj
          .set('initial_utm_source', utm_source)
          .set('initial_utm_medium', utm_medium)
          .set('initial_utm_campaign', utm_campaign);
      } else {
        // Infer from referrer if no UTM present
        if (document.referrer.includes('facebook.com')) {
          identifyObj.set('initial_utm_source', 'facebook');
        } else if (document.referrer.includes('instagram.com')) {
          identifyObj.set('initial_utm_source', 'instagram');
        } else if (document.referrer.includes('t.co') || document.referrer.includes('twitter.com')) {
          identifyObj.set('initial_utm_source', 'twitter');
        } else if (document.referrer.includes('google.com')) {
          identifyObj.set('initial_utm_source', 'google');
        } else if (document.referrer) {
          identifyObj.set('initial_utm_source', 'referral');
        } else {
          identifyObj.set('initial_utm_source', 'direct');
        }
      }

      identify(identifyObj);
      localStorage.setItem('utmTracked', 'true');
      console.log('UTM or referrer source set in Amplitude');
    }

  }, [location]);

  return null;
};

export default RouteChangeTracker;
